module.exports = __webpack_public_path__ + "static/abad-598d490c7b055e081a7f949200b762a3.png";